import React, { useCallback, useState } from 'react';
import { Input, InputContainer } from 'finform';
import { Api } from 'laravel-request';
import { useAppSelector } from '#app/hooks/useAppStore';
import { useActives } from '#app/pages/IncomeAndExpenses/components/ActivesContext';

const InputDesc = ({ item, finishEdit }) => {
  const client = useAppSelector((s) => s.interfaceComponents.client);
  const { setPreparedActives } = useActives();
  const [value, setValue] = useState(item.comment);

  const updateComment = useCallback(
    (newComment) => {
      setPreparedActives((prev) =>
        prev.map((year) => ({
          ...year,
          months: year.months.map((month) => ({
            ...month,
            dates: month.dates.map((date) => ({
              ...date,
              items: date.items.map((op) =>
                op.id === item.id ? { ...op, comment: newComment } : op
              ),
            })),
          })),
        }))
      );
    },
    [item.id, setPreparedActives]
  );

  const updateItemInState = useCallback(
    (value, callback) => {
      updateComment(value);
      callback && callback();
    },
    [updateComment]
  );

  const storeActiveComment = useCallback(
    (text) => {
      Api.putArg('active', 'comment', item.id, {
        comment: text,
        user_id: client?.id || '',
      }).call();
    },
    [item.id, client]
  );

  const handleChange = useCallback(
    (value) => {
      setValue(value);
      updateItemInState(value);
    },
    [updateItemInState]
  );

  const onBlur = useCallback(() => {
    if (item.oldComment !== value) {
      updateItemInState(value, () => {
        storeActiveComment(value);
      });
    }
    finishEdit();
  }, [value, item.oldComment, updateItemInState, storeActiveComment, finishEdit]);

  return (
    <div style={{ alignItems: 'center', display: 'flex' }}>
      <InputContainer
        style={{
          height: '24px',
          maxWidth: '110px',
          minWidth: '110px',
          margin: '0 10px',
        }}
      >
        <Input
          style={{ height: '24px', width: '85px', padding: '0 2px 2px 8px' }}
          id={`incomes-and-expenses-desc-${item.id}`}
          value={value}
          onChange={handleChange}
          onBlur={onBlur}
          icon={false}
        />
      </InputContainer>
    </div>
  );
};

export default InputDesc;
